<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :search="search"
    dense
    :footer-props="{
      'items-per-page-text': 'Elementos por página',
      itemsPerPageAllText: 'Todos',
    }"
    :hide-default-footer="hideFooter"
    :items-per-page="5"
    item-key="id"
    class="mt-5"
  >
    <v-progress-linear
      slot="progress"
      color="primary"
      indeterminate
    ></v-progress-linear>
    <template v-slot:item.estado="{ item }">
      <v-chip
        v-if="item.estado || item.registered"
        small
        rounded
        outlined
        color="success"
        dark
        >Activo</v-chip
      >
      <v-chip v-else small rounded outlined color="error">Inactivo</v-chip>
    </template>
    <template v-slot:item.begin="{ item }">
      <span v-text="date(item.fecha_inicio_plan)"></span>
    </template>
    <template v-slot:item.create="{ item }">
      <span v-text="date(item.evnp_fecha_creacion)"></span>
    </template>
    <template v-slot:item.employee_name="{ item }">
      <span
        v-text="
          item.conductor_nombre +
            ' ' +
            item.conductor_apellido_paterno +
            ' ' +
            item.conductor_apellido_materno
        "
      />
    </template>
    <template v-slot:item.route_name="{ item }">
      <span v-text="item.ruta_idruta + ' ' + item.ruta_nombre_ruta" />
    </template>
    <template v-slot:item.all_routes="{ item }">
      <span v-text="item.rutas[0].nombre_ruta" />
      <infoBtn
        text="Ver más"
        :onClick="slotsActions"
        icon="mdi-plus"
        colorBtn="green"
        :permission="false"
        :data="['allClient', item]"
      />
    </template>
    <template v-if="slots === 'state'" v-slot:item.action="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-tooltip :disabled="!item.estado" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                :color="!item.estado ? 'grey' : 'error'"
                dark
                v-bind="attrs"
                v-on="on"
                @click="remove(item)"
              >
                mdi-account-remove
              </v-icon>
            </template>
            <span>desactivar</span>
          </v-tooltip>
        </template>
        <span>Desactivar acceso</span>
      </v-tooltip>
    </template>
    <template v-if="slots === 'detail'" v-slot:item.actions="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                color="blueKonect"
                dark
                v-bind="attrs"
                v-on="on"
                @click="view(item)"
              >
                mdi-eye
              </v-icon>
            </template>
            <span>Detalle</span>
          </v-tooltip>
        </template>
        <span>Detalle</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                color="error"
                dark
                v-bind="attrs"
                v-on="on"
                @click="onRemove2(item.referencia_empleado)"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <span>Eliminar</span>
      </v-tooltip>
    </template>
    <template v-slot:footer.page-text="props">
      Página {{ props.pageStart }} - {{ props.pageStop }} de
      {{ props.itemsLength }}
    </template>
    <template v-slot:no-data>
      No hay información disponible
    </template>
    <template v-slot:no-results>
      No se obtuvieron resultados
    </template>
  </v-data-table>
</template>

<script>
import moment from "moment";
const props = {
  headers: {
    default: [],
    type: Array,
  },
  items: {
    default: [],
    type: Array,
  },
  loading: {
    default: false,
    type: Boolean,
  },
  search: {
    default: "",
    type: String,
  },
  hideFooter: {
    default: false,
    type: Boolean,
  },
  onRemove: Function,
  onRemove2: Function,
  slotsActions: Function,
  reading: {
    default: false,
    type: Boolean,
  },
  writing: {
    default: false,
    type: Boolean,
  },
  removing: {
    default: false,
    type: Boolean,
  },
  slots: {
    default: "state",
    type: String,
  },
};

export default {
  data: () => ({}),
  beforeCreate() {
    //Asi se llaman componentres dentro de componentes
    this.$options.components.infoBtn = require("@/components/infoBtn.vue").default;
  },
  methods: {
    remove(id) {
      this.onRemove(id.idusuario_externo);
    },
    view(id) {
      this.onRemove(id);
    },
    date(value) {
      return moment(value).format("YYYY-MM-DD hh:mm");
    },
  },
  props: props,
};
</script>

<style scoped></style>
